import { render, staticRenderFns } from "./audio-item.vue?vue&type=template&id=1676a442"
import script from "./audio-item.vue?vue&type=script&lang=js"
export * from "./audio-item.vue?vue&type=script&lang=js"
import style0 from "./audio-item.vue?vue&type=style&index=0&id=1676a442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports